import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { GigPiece_Entity } from "../../entities/gigPiece";
import { Ids } from "../../reducers/rhapsody";

const gigPiecesAdapter = createEntityAdapter<GigPiece_Entity>();
const initialState = gigPiecesAdapter.getInitialState();

export const gigPieceEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getGigPieces: build.query<EntityState<GigPiece_Entity>, void>({
      query: () => `gigPieces`,
      transformResponse: (responseData: GigPiece_Entity[]) => {
        return gigPiecesAdapter.setAll(initialState, responseData);
      },
      providesTags: ["gigPieces"],
    }),
    getGigPiece: build.query<GigPiece_Entity, Ids>({
      query: (arg) => {
        return {
          url: `gigPieces/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["gigPieces"],
    }),
    createGigPiece: build.mutation<GigPiece_Entity, Partial<GigPiece_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `gigPieces`,
      }),
      invalidatesTags: ["gigPieces"],
    }),
    updateGigPiece: build.mutation<
      void,
      { id: number; body: Partial<GigPiece_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `gigPieces/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "gigPieces", id },
        "gigPieces",
      ],
    }),
    deleteGigPiece: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `gigPieces/${id}`,
      }),
      invalidatesTags: ["gigPieces"],
    }),
  }),
});

export const {
  useGetGigPieceQuery,
  useGetGigPiecesQuery,
  useCreateGigPieceMutation,
  useDeleteGigPieceMutation,
  useUpdateGigPieceMutation,
} = gigPieceEndpoints;

export default gigPieceEndpoints;
